import mutations from "@/store/mutations";
import * as MUTATIONS from "@/config/constants/mutation-types";

describe("mutations.js test suite", () => {
  it("ON_ROUTE mutation test", () => {
    const state = { route: null };
    const payload = { name: "home", params: {} };

    mutations[MUTATIONS.ON_ROUTE](state, payload);
    expect(state.route).toEqual(payload);
  });

  it("ON_LANDING mutation test", () => {
    const state = { trackClickElement: false };
    const payload = true;

    mutations[MUTATIONS.ON_LANDING](state, payload);
    expect(state.isLoading).toBe(undefined);
  });

  it("ON_IS_LOADING mutation test", () => {
    const state = { isLoading: false };
    const payload = true;

    mutations[MUTATIONS.ON_IS_LOADING](state, payload);
    expect(state.isLoading).toBe(true);
  });

  it("ON_PASO_1 mutation test", () => {
    const state = { paso1: {} };
    const payload = { numeroCliente: "123456" };

    mutations[MUTATIONS.ON_PASO_1](state, payload);
    expect(state.paso1.numeroCliente).toBe(payload.numeroCliente);
  });

  it("ON_GRACIAS mutation test", () => {
    const state = { gracias: false };
    const payload = true;

    mutations[MUTATIONS.ON_GRACIAS](state, payload);
    expect(state.gracias).toBe(payload);
  });

  it("ON_ADOBE_APPSTARTED mutation test", () => {
    const state = { trackClickElement: false };
    const payload = true;

    mutations[MUTATIONS.ON_ADOBE_APPSTARTED](state, payload);
    expect(state.trackClickElement).toBe(payload);
  });
});
